import { styled } from "@mui/material/styles"
import Stack from "@mui/material/Stack"
import CircularProgress from "@mui/material/CircularProgress"

export default function Loading() {
  return (
    <LoadingContainer>
      <CircularProgress size={30} color="inherit"/>
    </LoadingContainer>
  )
}

const LoadingContainer = styled(Stack)(({ theme }) => ({
  width: "100%",
  height: "60px",
  justifyContent: "center",
  alignItems: "center",
  color: theme.palette.gray["12"]
}))
